export const VTMN_BADGE_VARIANT = {
  DEFAULT: 'default',
  BRAND: 'brand',
  REVERSED: 'reversed',
  ACCENT: 'accent',
  ALERT: 'alert',
};
